<template>
  <svg
    class="offing-point-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="22"
    viewBox="0 0 18 22"
    fill="none"
  >
    <path
      d="M9.0002 11C9.6052 11 10.1231 10.7846 10.5539 10.3538C10.9848 9.92292 11.2002 9.405 11.2002 8.8C11.2002 8.195 10.9848 7.67708 10.5539 7.24625C10.1231 6.81542 9.6052 6.6 9.0002 6.6C8.3952 6.6 7.87728 6.81542 7.44645 7.24625C7.01561 7.67708 6.8002 8.195 6.8002 8.8C6.8002 9.405 7.01561 9.92292 7.44645 10.3538C7.87728 10.7846 8.3952 11 9.0002 11ZM9.0002 19.085C11.2369 17.0317 12.896 15.1663 13.9777 13.4887C15.0594 11.8112 15.6002 10.3217 15.6002 9.02C15.6002 7.02167 14.9631 5.38542 13.6889 4.11125C12.4148 2.83708 10.8519 2.2 9.0002 2.2C7.14853 2.2 5.58561 2.83708 4.31145 4.11125C3.03728 5.38542 2.4002 7.02167 2.4002 9.02C2.4002 10.3217 2.94103 11.8112 4.0227 13.4887C5.10436 15.1663 6.76353 17.0317 9.0002 19.085ZM9.0002 22C6.04853 19.4883 3.84395 17.1554 2.38645 15.0013C0.928945 12.8471 0.200195 10.8533 0.200195 9.02C0.200195 6.27 1.08478 4.07917 2.85395 2.4475C4.62311 0.815833 6.67186 0 9.0002 0C11.3285 0 13.3773 0.815833 15.1464 2.4475C16.9156 4.07917 17.8002 6.27 17.8002 9.02C17.8002 10.8533 17.0714 12.8471 15.6139 15.0013C14.1564 17.1554 11.9519 19.4883 9.0002 22Z"
    />
  </svg>
</template>

<script>
export default {
  name: "OffingPointIcon",
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/aisea/_variables.scss";
.offing-point-icon {
  path {
    fill: #4d9ef2;
  }
}
</style>
